import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout';
import { speak } from './speech';
import '../assets/scss/challenge.scss';
import '../assets/scss/v1plus.scss';

// I. Review: v1 challenge-result cards (today's review first) + list of notes and free practice
export const Review = () => {
  const [h, setH] = useState(null);
  const [last, setLast] = useState(null);
  useEffect(() => {
    axios.get('/api/learn/home').then(res => setH(res.data)).catch(() => setH({ due: 0 }));
    axios.get('/api/challenge/results').then(res => setLast(res.data[0] || null)).catch(() => { });
  }, []);

  return (
    <Layout header={{ title: '복습', Backbtn: true, link: '/Main' }} containName='result v1-keep'>
      <div className="result-wrap">
        <strong>Today</strong>
        <ul className="result-list">
          <li className="v1-result-item violet">
            <Link to={h && h.due > 0 ? '/Review/Session' : '/Review'}>
              <p className="date">오늘 복습</p>
              <strong className="number">{h ? h.due : '-'}</strong>
              <p style={{ marginTop: 20, fontSize: 12 }}>{h && h.due > 0 ? '눌러서 시작 ›' : '지금은 복습할 단어가 없어요'}</p>
            </Link>
          </li>
          {last && (
            <li>
              <Link to={`/Challenge/Detail?id=${last.id}`}>
                <p className="date">최근 챌린지 · {new Date(last.created_at).toLocaleDateString()}</p>
                <strong className="number">{last.score}<span style={{ fontSize: 16 }}>/{last.total}</span></strong>
                <div className="length">
                  <div className="answer"><p>정답수</p><p className="count">{last.score}</p></div>
                  <div className="incorrect"><p>오답수</p><p className="count">{last.wrong_count}</p></div>
                </div>
              </Link>
            </li>
          )}
        </ul>
      </div>

      <div className="result-wrap" style={{ marginTop: 40 }}>
        <strong>Notes</strong>
        <div className="v1-rows">
          <Link to="/Review/Words/wrong"><span className="ic" style={{ background: '#F64848' }}>!</span><span className="t"><strong>오답노트</strong><small>한 번이라도 틀린 단어</small></span><span className="go" /></Link>
          <Link to="/Review/Words/starred"><span className="ic" style={{ background: '#FFC61A', color: '#5A4300' }}>★</span><span className="t"><strong>내 단어장</strong><small>별표한 단어</small></span><span className="go" /></Link>
          <Link to="/Review/Words/all"><span className="ic" style={{ background: '#2E9E5B' }}>✓</span><span className="t"><strong>배운 단어 전체</strong><small>지금까지 배운 모든 단어</small></span><span className="go" /></Link>
          <Link to="/Challenge"><span className="ic" style={{ background: '#6153FF' }}>⚑</span><span className="t"><strong>챌린지 시험</strong><small>원하는 개수로 타이핑 시험</small></span><span className="go" /></Link>
          <Link to="/Study/Free"><span className="ic" style={{ background: '#FA7D38' }}>↻</span><span className="t"><strong>자유 학습</strong><small>원하는 개수만큼 단어 카드 보기</small></span><span className="go" /></Link>
          <Link to="/Challenge/Result"><span className="ic" style={{ background: '#242424' }}>▦</span><span className="t"><strong>챌린지 결과</strong><small>지금까지 본 시험 기록</small></span><span className="go" /></Link>
        </div>
      </div>
    </Layout>
  );
};

const FILTERS = [{ id: 'wrong', label: '오답만' }, { id: 'starred', label: '별표만' }, { id: 'all', label: '전체' }];

// J. Word notes: v1 detail list with the dropdown filter and the orange floating menu
export const WordList = () => {
  const { filter } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const [fab, setFab] = useState(false);
  useEffect(() => {
    setRows(null);
    axios.get(`/api/learn/words?filter=${filter}`).then(res => setRows(res.data)).catch(() => setRows([]));
  }, [filter]);

  const toggle = async (w) => {
    const starred = !w.starred;
    setRows(rs => rs.map(r => (r.id === w.id ? { ...r, starred } : r)));
    try { await axios.post('/api/learn/star', { wordId: w.id, starred }); } catch (e) { setRows(rs => rs.map(r => (r.id === w.id ? w : r))); }
  };
  const current = FILTERS.find(f => f.id === filter) || FILTERS[2];

  return (
    <Layout header={{ title: filter === 'starred' ? '내 단어장' : filter === 'wrong' ? '오답노트' : '배운 단어', Backbtn: true, link: '/Review' }} containName='result v1-keep'>
      <div className="select-wrap">
        <div className={`select ${open ? 'active' : ''}`}>
          <button type="button" onClick={() => setOpen(!open)} aria-expanded={open}>{current.label}</button>
          <ul style={{ display: open ? 'block' : 'none' }}>
            {FILTERS.map(f => <li key={f.id} className={f.id === filter ? 'active' : ''} onClick={() => { setOpen(false); navigate(`/Review/Words/${f.id}`, { replace: true }); }}>{f.label}</li>)}
          </ul>
        </div>
      </div>

      <div className="v1-list">
        {!rows ? <p className="v1-guide">불러오는 중...</p> : !rows.length ? (
          <p className="v1-guide">{filter === 'starred' ? '별표한 단어가 없어요. ☆를 눌러 추가하세요.' : filter === 'wrong' ? '틀린 단어가 없어요. 잘하고 있어요!' : '아직 배운 단어가 없어요.'}</p>
        ) : rows.map(w => (
          <div key={w.id} className="v1-row">
            <span className="t">
              <span className="w">{w.word}</span>
              <span className="m">{w.meaning}</span>
              {w.wrong_count > 0 && <span className="x">{w.wrong_count}번 틀림</span>}
            </span>
            <button type="button" className="v1-star" aria-label={w.starred ? '별표 해제' : '별표'} onClick={() => toggle(w)}>{w.starred ? '★' : '☆'}</button>
            <button type="button" className="v1-snd" aria-label="발음 듣기" onClick={() => speak(w.word)} />
          </div>
        ))}
      </div>

      <div className="v1-fab-wrap">
        {fab && <div className="v1-fab-dim" onClick={() => setFab(false)} />}
        {fab && (
          <div className="v1-fab-menu">
            <button type="button" onClick={() => navigate('/Review/Session')}>오늘 복습 시작<i>↻</i></button>
            <button type="button" onClick={() => navigate('/Study')}>오늘의 레슨<i>▶</i></button>
          </div>
        )}
        <button type="button" className={`v1-fab ${fab ? 'on' : ''}`} aria-label="메뉴" onClick={() => setFab(!fab)}>+</button>
      </div>
    </Layout>
  );
};
